<template>
  <div class="top-banner-title">
    <!--      top left svg 1-->
    <img
      v-if="imgType !== 'world'"
      alt="star svg"
      data-src="@images/public/home/banner/banner-1.svg"
      width="44"
      height="44"
      class="lazyload top-left-svg"
    >
    <!--      title-->
    <div
      class="relative"
      :class="titleClass"
    >
      <h1
        class="banner-title "
      >
        {{ title }}
      </h1>
      <!--        right bottom svg 2-->
      <img
        v-if="imgType === 'home' || imgType === 'world'"
        alt="light svg"
        data-src="@images/public/home/banner/banner-2.svg"
        width="34"
        height="34"
        class=" lazyload bottom-right-svg"
      >
    </div>
    <!--pre title-->
    <div class="lg:w-max">
      <h2
        class="banner-description"
      >
        {{ subtitle }}
      </h2>
      <img
        v-if="imgType === 'start-teaching'"
        alt="smile"
        data-src="@images/start-teaching/landing/smile.png"
        width="38"
        height="39"
        class="lazyload float-right -mr-2"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeTopBannerTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: 'max-w-full lg:max-w-[512px] text__headline-3-xs--bold lg:text__headline-3-md--bold'
    },
    subtitle: {
      type: String,
      default: ''
    },
    imgType: {
      type: String,
      default: 'home'
    }
  }

}
</script>

<style lang="scss"  scoped>
.banner-title{
  @apply text-primary-700 sm:shrink-0 mb-3 lg:mb-2 inline w-full text-center lg:text-left;
}
.banner-description{
  @apply text__headline-4-xs--semibold lg:text__headline-5-md--regular text-body-1 text-center lg:text-left mt-2;
}
.top-left-svg {
  @apply lg:max-w-[44px] max-w-[24px] h-auto;
}
.bottom-right-svg {
  @apply lg:max-w-[34px] max-w-[24px] h-auto inline-block mt-5;
}
</style>
